function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Accounting } from "../types/api.model";
import { ContactIntegrationsModel } from "./ContactIntegrations";
export let ContactAccountantAccess = /*#__PURE__*/function (ContactAccountantAccess) {
  ContactAccountantAccess["NonCandidate"] = "nonCandidate";
  ContactAccountantAccess["Candidate"] = "candidate";
  ContactAccountantAccess["Invited"] = "invited";
  ContactAccountantAccess["Active"] = "active";
  return ContactAccountantAccess;
}({});
export let ContactEditMode = /*#__PURE__*/function (ContactEditMode) {
  ContactEditMode["Editable"] = "editable";
  ContactEditMode["Readonly"] = "readonly";
  return ContactEditMode;
}({});
export let ContactStatus = /*#__PURE__*/function (ContactStatus) {
  ContactStatus["Active"] = "active";
  ContactStatus["Archived"] = "archived";
  return ContactStatus;
}({});
export class ContactModel {
  static uniqueKey(_ref) {
    let {
      companyName,
      email
    } = _ref;
    return (companyName.trim() + email.trim()).toLowerCase();
  }
  static makeSample(_ref2) {
    let {
      createdAt,
      vendorId = ''
    } = _ref2;
    return new ContactModel({
      id: 'sample_contact_id',
      createdAt: createdAt.getTime(),
      firstName: 'Sample',
      lastName: 'Client',
      companyName: 'Anchor (Sample)',
      email: 'sampleclient@sayanchor.com',
      phone: null,
      isSample: true,
      edit: {
        mode: ContactEditMode.Readonly
      },
      vendorId,
      version: 'sample_contact_version',
      accountantAccess: ContactAccountantAccess.NonCandidate,
      status: ContactStatus.Active,
      hasSignedAgreements: true,
      hasPendingProposals: false,
      integrations: []
    });
  }
  constructor(dto) {
    this.dto = dto;
  }
  toJSON() {
    return this.dto;
  }
  toAssignedUser() {
    return {
      id: this.dto.id,
      firstName: this.dto.firstName,
      lastName: this.dto.lastName,
      email: this.dto.email,
      phone: this.dto.phone
    };
  }
  id() {
    return this.dto.id;
  }
  vendorId() {
    return this.dto.vendorId;
  }
  companyName() {
    return this.dto.companyName;
  }
  firstName() {
    return this.dto.firstName;
  }
  lastName() {
    return this.dto.lastName;
  }
  email() {
    return this.dto.email;
  }
  customerId() {
    return this.dto.customerId;
  }
  isSample() {
    return this.dto.isSample;
  }
  isEditable() {
    return this.dto.edit.mode === ContactEditMode.Editable;
  }
  isEmailEditable() {
    return this.dto.edit.mode === ContactEditMode.Editable ? this.dto.edit.editable.isEmailEditable : false;
  }
  integratedId(_ref3) {
    let {
      accounting
    } = _ref3;
    const integrations = this.integrations();
    switch (accounting) {
      case Accounting.QBO:
        return integrations.qboIntegratedId();
      case Accounting.Xero:
        return integrations.xeroIntegratedId();
    }
  }
  integrations() {
    return ContactIntegrationsModel.fromDTO(this.dto.integrations);
  }
  isIntegrated(_ref4) {
    let {
      accounting
    } = _ref4;
    return !!this.integratedId({
      accounting
    });
  }
  version() {
    return this.dto.version;
  }
  phone() {
    return this.dto.phone;
  }
  hasPendingProposals() {
    return this.dto.hasPendingProposals;
  }
  hasSignedAgreements() {
    return this.dto.hasSignedAgreements;
  }
  fullName() {
    return "".concat(this.dto.firstName, " ").concat(this.dto.lastName);
  }
  accountantAccess() {
    return this.dto.accountantAccess;
  }
  status() {
    return this.dto.status;
  }
  isActive() {
    return this.dto.status === ContactStatus.Active;
  }
  uniqueKey() {
    return ContactModel.uniqueKey(this.dto);
  }
  update(changes) {
    return new ContactModel(_objectSpread(_objectSpread(_objectSpread({}, this.dto), changes), {}, {
      version: this.dto.version
    }));
  }
}
export class NewContactModel {
  static make(newContact) {
    return new NewContactModel(newContact);
  }
  static makeEmpty() {
    return new NewContactModel({
      firstName: '',
      lastName: '',
      companyName: '',
      email: '',
      phone: ''
    });
  }
  constructor(dto) {
    this.dto = dto;
  }
  toJSON() {
    return this.dto;
  }
  hasPartialContactDetails() {
    return hasPartialContactDetails(this.dto);
  }
  uniqueKey() {
    return ContactModel.uniqueKey(this.dto);
  }
  isSample() {
    return false;
  }
}
function hasPartialContactDetails(_ref5) {
  let {
    firstName,
    lastName,
    companyName,
    email,
    phone
  } = _ref5;
  return !!(firstName || lastName || companyName || email || phone);
}